import * as React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import styles from './navbar.module.css';
import { PageDisplay } from '../pageDisplay';

export const MainNavbar = (props) => {
  return (
    <div title="Navbar" className={styles.navbar}>
      <Navbar bg="dark" className={styles.innerNav} variant="dark">
        <Navbar.Brand href="https://synergyroleplay.com/forums/">
          <img
            src="https://synergyroleplay.com/forums/uploads/monthly_2022_02/Banner-Transparent.png.730a2e91a684212fd78dbb0a8af3e8dc.png.df2795030db8247833c70ed76e472cd5.png"
            alt="SynergyLogo"
            width="200"
            height="100"
          />
        </Navbar.Brand>
        <PageDisplay
          pageNumber={props.pageNumber}
          setPageNumber={props.setPageNumber}
          totalNumberOfBans={props.totalNumberOfBans}
        />
      </Navbar>
    </div>
  );
};
